import { AppState } from '../../../redux/reducers';
import { ErrorType } from '../../../models/HttpError';

// models
import { ContractCommissionAgent } from '../../../models/Entities/Contracts/ContractCommissionAgent';

// stores
import * as ContractCommissionAgentStore from '../../../redux/middleware/ContractCommissionAgentMiddleware';

export interface IProps {
  ContractId: number;
  /** Comisionista a editar. Sin esto el formulario da de alta uno nuevo. */
  Agent?: ContractCommissionAgent | undefined;
  isOpen: boolean;
  dismissPanel: () => void;
}

interface ConnectedProps {
  isSaving: boolean;
  isSavedSuccessfully: boolean;
  isUpdating: boolean;
  isUpdatedSuccessfully: boolean;
  failOnSaving: boolean;
  failOnUpdating: boolean;
  error: ErrorType | undefined;
}

interface DispatchProps {
  CreateContractCommissionAgent: typeof ContractCommissionAgentStore.actionCreators.CreateContractCommissionAgent;
  UpdateContractCommissionAgent: typeof ContractCommissionAgentStore.actionCreators.UpdateContractCommissionAgent;
}

export type Props = IProps & ConnectedProps & DispatchProps;

/* Las banderas de guardado viven en el contrato y no en el estado de
   comisionistas: es el reducer del contrato el que las mueve al crear y
   actualizar un agente. Se leen del mismo lugar que las lee el formulario del
   equipo médico, para que las dos pantallas coincidan en cuándo se está
   guardando. */
export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isSaving: state.Contract?.isSaving,
  isSavedSuccessfully: state.Contract?.isSavingSuccess,
  isUpdating: state.Contract?.isUpdatingAll,
  isUpdatedSuccessfully: state.Contract?.isUpdatingAllSuccess,
  failOnSaving: state.Contract?.FailSaving,
  failOnUpdating: state.Contract?.FailUpdatingAll,
  error: state.ContractCommissionAgent?.error,
  ...ownProps
});

export const mapDispatchToProps = {
  ...ContractCommissionAgentStore.actionCreators
};
